import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../utils/apiBaseQuery";
import { FunctionGroupInterface } from "../interfaces/FunctionGroupInterface";
import { MetaInterface } from "../interfaces/MetaInterface";
import { ApiEnum } from "../enums/ApiEnum";
import { createQueryString } from "../utils/createQueryString";

export const functionGroupApiSlice = createApi({
    reducerPath: "functionGroupApiSlice",
    baseQuery: apiBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        getFunctionGroups: builder.query<
            {
                data: FunctionGroupInterface[];
                meta?: MetaInterface;
            },
            {
                page?: number;
                items_per_page?: number;
            }
        >({
            query: (values) => {
                return {
                    url: `${ApiEnum.FUNCTION_GROUP}?${createQueryString(values)}`,
                    method: "GET",
                };
            },
        }),
    }),
});

export default functionGroupApiSlice.reducer;

export const { useGetFunctionGroupsQuery } = functionGroupApiSlice;
